import {
    buildAuthorizedAuthHydrationForClient,
    buildAuthorizedSessionForClient,
    bindAuthorizedSessionRefreshForClient,
    extractRolesFromToken,
    OidcAuthenticatedUser,
} from './tokenRoleExtraction';

const configuredClientId = () => import.meta.env.VITE_OIDC_CLIENT_ID || 'recruitment-app';

export const getRealmRolesFromToken = (token?: string | null): string[] =>
    extractRolesFromToken(token, configuredClientId());

export interface AuthorizedRoleHydration {
    primaryRole: string;
    roles: string[];
}

export const getAuthorizedRoleHydration = (token?: string | null): AuthorizedRoleHydration => {
    const roles = getRealmRolesFromToken(token);
    return {
        primaryRole: roles[0] ?? 'user',
        roles,
    };
};

interface OidcProfileIdentity {
    sub?: string;
    preferred_username?: string;
    email?: string;
    name?: string;
}

export const buildAuthorizedAuthHydration = (
    token: string | null | undefined,
    profile: OidcProfileIdentity,
) => buildAuthorizedAuthHydrationForClient(token, profile, configuredClientId());

export const buildAuthorizedSession = (user: OidcAuthenticatedUser) =>
    buildAuthorizedSessionForClient(user, configuredClientId());

export const bindAuthorizedSessionRefresh = (
    subscribe: (listener: (user: OidcAuthenticatedUser) => void) => () => void,
    replaceSession: (session: ReturnType<typeof buildAuthorizedSession>) => void,
    afterSessionReplaced?: () => void,
) => bindAuthorizedSessionRefreshForClient(
    subscribe,
    replaceSession,
    configuredClientId(),
    afterSessionReplaced,
);

